<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-8">
          <strong class="card-title mb-3">P Score Analysis</strong>
        </div>
        <div class="col-md-3">
          <download :tableId="'pscoreanalysis'" :fileName="'p-score-analysis'"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb-15">
        <div class="col-md-3">
          <div class="form-group">
            <datepicker
              :input-class="'form-control'"
              :format="'dd-MM-yyyy'"
              v-model="ddate"
              @selected="getDateData($event)"
            ></datepicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <!-- <label class="form-control-label">Fields Type</label> -->
            <select class="form-control" v-model="p_name" name="p_name">
              <option value>Select Field Type</option>
              <option v-for="(f, index) in field_types" :value="index" :key="index">{{f.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3 br">
          <div class="form-group">
            <button type="button" class="btn btn-sm" @click="filter">Go</button>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              type="text"
              placeholder="Seach by Company name"
              class="form-control"
              v-model="searchText"
              @keyup="searchCompany()"
            />
          </div>
        </div>
      </div>
      <div class="row mb-15">
        <div class="col-md-3">
          <label class v-if="uniqueCoCode.length>0">
            <h4>
              <!-- {{uniqueCoCode[0]}} -->
              {{
              (rawData['one_day'][uniqueCoCode[0]['co_code']] && rawData['one_day'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['one_day'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['one_week'][uniqueCoCode[0]['co_code']] && rawData['one_week'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['one_week'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['one_month'][uniqueCoCode[0]['co_code']] && rawData['one_month'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['one_month'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['three_month'][uniqueCoCode[0]['co_code']] && rawData['three_month'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['three_month'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['six_month'][uniqueCoCode[0]['co_code']] && rawData['six_month'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['six_month'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['one_year'][uniqueCoCode[0]['co_code']] && rawData['one_year'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['one_year'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['two_year'][uniqueCoCode[0]['co_code']] && rawData['two_year'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['two_year'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['three_year'][uniqueCoCode[0]['co_code']] && rawData['three_year'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['three_year'][uniqueCoCode[0]['co_code']].today_date)
              : (rawData['five_year'][uniqueCoCode[0]['co_code']] && rawData['five_year'][uniqueCoCode[0]['co_code']].today_date)? 'Date: '+getDate(rawData['five_year'][uniqueCoCode[0]['co_code']].today_date)
              : ''}}
            </h4>
          </label>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table id="pscoreanalysis" class="table table-bordered fonts11 app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th
                @click="sortColumn(field, ind)"
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, ind, key) in tableFields"
                v-bind:key="'field'+field.title+ind+key"
              >
                {{field.name}}
                <!-- <span v-if="field.isSortable">
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort_order == 1 || field.sort_order == 0)"
                  ></i>
                  <i
                    class="fa fa-caret-up"
                    v-else-if="(field.sort_order == 2 || field.sort_order == 0)"
                  ></i>
                </span>-->
              </th>
              <th
                style="font-size:.92em"
                class="data-cell column-sort"
                v-for="(field, ind, key) in tableRows"
                v-bind:key="'field'+field.title+ind+key"
              >{{field.name}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in uniqueCoCode" v-bind:key="'row'+row+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="'td'+field.title+index">
                <span v-if="field.isLink">
                  <a class="a-btn" @click.prevent="showCompDetails(row)">{{ row[field.title]}}</a>
                </span>
                <span
                  v-if="field.title==='date'"
                >{{(row[field.title])? getDate(row[field.title]): '-'}}</span>
                <span
                  v-if="field.title!=='date' && !field.isLink"
                >{{(field.isNumeric)? getFixed2dec(row[field.title]): row[field.title]}}</span>
                <!-- <span>{{(row[field.title] !== null)? getFixed2dec(row[field.title]): (row[field.title]==0 || row[field.title]=="0")? 0:'-'}}</span> -->
              </td>
              <td
                v-for="field in tableRows"
                v-bind:key="'td'+field.title"
              >{{(rawData[field.title][row.co_code])? getFixed2dec(rawData[field.title][row.co_code].score) : '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { pCommonMixins } from "../../assets/mixins/pcommon.js";
import Datepicker from "vuejs-datepicker";
export default {
  components: { Datepicker },
  mixins: [commonMixins, pCommonMixins],
  created() {
    this.getPScore();
  },
  data() {
    return {
      searchText: "",
      ddate: new Date().setDate(new Date().getDate() - 1),
      tabs: [
        { title: "p1_S", name: "P1 S", rawDataApi: "getPSumData" },
        { title: "p2_S", name: "P2 S", rawDataApi: "getPSumData" },
        { title: "p3_S", name: "P3 S", rawDataApi: "getPSumData" },
        { title: "p4_S", name: "P4 S", rawDataApi: "getPSumData" },
        { title: "p5_a_S", name: "P5 A S", rawDataApi: "getPSumData" },
        { title: "p5_b_S", name: "P5 B S", rawDataApi: "getPSumData" },
        { title: "p6_a", name: "P6 A S", rawDataApi: "getPSumData" },
        { title: "p6_b", name: "P6 B S", rawDataApi: "getPSumData" },
        { title: "p7_a_S", name: "P7 A S", rawDataApi: "getPSumData" },
        { title: "p7_b_S", name: "P7 B S", rawDataApi: "getPSumData" },
        { title: "p8_a_S", name: "P8 A S", rawDataApi: "getPSumData" },
        { title: "p8_b_S", name: "P8 B S", rawDataApi: "getPSumData" },
        { title: "p9_S", name: "P9 S", rawDataApi: "getP9SumData" },
        { title: "p10_S", name: "P10 S", rawDataApi: "getPSumData" },
        { title: "p11_S", name: "P11 S", rawDataApi: "getPSumData" },
        { title: "q1_S", name: "Q1 S", rawDataApi: "getPSumData" },
        { title: "q1_a_S", name: "Q1 A S", rawDataApi: "getPSumData" },
        { title: "q1_b_S", name: "Q1 B S", rawDataApi: "getPSumData" },
        { title: "q1_c_S", name: "Q1 C S", rawDataApi: "getPSumData" },
        { title: "q1_d_S", name: "Q1 D S", rawDataApi: "getPSumData" },
        {
          title: "return-analysis",
          name: "Return Analysis",
          rawDataApi: "getReturnAnalysis"
        }
      ],
      field_types: [
        { title: "price", name: "Price", rawDataApi: "getpriceScoreAnalysis" },
        {
          title: "volume",
          name: "Volume",
          rawDataApi: "getpriceScoreAnalysis"
        },
        { title: "p1_S", name: "P1 S", rawDataApi: "getPScoreAnalysis" },
        { title: "p2_S", name: "P2 S", rawDataApi: "getPScoreAnalysis" },
        { title: "p3_S", name: "P3 S", rawDataApi: "getPScoreAnalysis" },
        { title: "p4_S", name: "P4 S", rawDataApi: "getPScoreAnalysis" },
        { title: "p5_a_S", name: "P5 A S", rawDataApi: "getPScoreAnalysis" },
        { title: "p5_b_S", name: "P5 B S", rawDataApi: "getPScoreAnalysis" },
        { title: "p6_a_S", name: "P6 A S", rawDataApi: "getPScoreAnalysis" },
        { title: "p6_b_S", name: "P6 BS", rawDataApi: "getPScoreAnalysis" },
        { title: "p7_a_S", name: "P7 A S", rawDataApi: "getPScoreAnalysis" },
        { title: "p7_b_S", name: "P7 B S", rawDataApi: "getPScoreAnalysis" },
        { title: "p8_a_S", name: "P8 A S", rawDataApi: "getPScoreAnalysis" },
        { title: "p8_b_S", name: "P8 B S", rawDataApi: "getPScoreAnalysis" },
        { title: "p10_S", name: "P10 S", rawDataApi: "getPScoreAnalysis" },
        { title: "p11_S", name: "P11 S", rawDataApi: "getPScoreAnalysis" },
        {
          title: "q1_a_b_greater",
          name: "Greater Q1 A/Q1 B",
          rawDataApi: "getPScoreAnalysis"
        },
        {
          title: "p11_quarterly_trends",
          name: "Quarterly Trend",
          rawDataApi: "getPScoreAnalysis"
        },
        { title: "q1_S", name: "Q1 S", rawDataApi: "getPScoreAnalysis" },
        { title: "q1_a_S", name: "Q1 A S", rawDataApi: "getPScoreAnalysis" },
        { title: "q1_b_S", name: "Q1 B S", rawDataApi: "getPScoreAnalysis" },
        { title: "q1_c_S", name: "Q1 C S", rawDataApi: "getPScoreAnalysis" },
        { title: "q1_d_S", name: "Q1 D S", rawDataApi: "getPScoreAnalysis" }
      ],
      timePeriod: [
        { title: "one_month_previous", name: "1 Month" },
        { title: "two_month_previous", name: "2 Months" },
        { title: "three_month_previous", name: "3 Months" },
        { title: "six_month_previous", name: "6 Months" },
        { title: "last_year", name: "1 Year" },
        { title: "two_year_previous", name: "2 Years" },
        { title: "three_year_previous", name: "3 Years" },
        { title: "five_year_previous", name: "5 Years" }
      ],
      tableRows: [
        { title: "one_day", name: "1 Day" },
        { title: "one_week", name: "1 Week" },
        { title: "one_month", name: "1 Month" },
        { title: "three_month", name: "3 Months" },
        { title: "six_month", name: "6 Months" },
        { title: "one_year", name: "1 Year" },
        { title: "two_year", name: "2 Years" },
        { title: "three_year", name: "3 Years" },
        { title: "five_year", name: "5 Years" }
      ],
      p_name: 0,
      duration_val: 0,
      rawDataApi: "getPScoreAnalysis",
      rawData: [],
      searchData: [],
      tableFields: [
        {
          title: "co_code",
          name: "Code",
          isNumeric: false,
          type: "string",
          isSortable: false,
          sort_order: ""
        },
        {
          title: "name",
          name: "Company",
          isNumeric: false,
          type: "string",
          isSortable: true,
          sort_order: ""
        }
        // {
        //   title: "one_week",
        //   name: "1 Week",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // }
        // {
        //   title: "one_month",
        //   name: "1 Month",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // },
        // {
        //   title: "three_month",
        //   name: "3 Months",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // },
        // {
        //   title: "six_month",
        //   name: "6 Months",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // },
        // {
        //   title: "one_year",
        //   name: "1 Year",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // },
        // {
        //   title: "two_year",
        //   name: "2 Years",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // },
        // {
        //   title: "three_year",
        //   name: "3 Years",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // },
        // {
        //   title: "five_year",
        //   name: "5 Years",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // }
        // {
        //   title: "score",
        //   name: "Score",
        //   isNumeric: true,
        //   type: "number",
        //   isSortable: true,
        //   sort_order: ""
        // }
      ],
      uniqueCoCode: [],
      searchData: []
    };
  },
  methods: {
    getPScore() {
      let params = {
        p_name: this.field_types[this.p_name].title,
        my_date: this.getDate(this.ddate)
        // duration_val: this.timePeriod[this.duration_val].title
      };
      this.rawDataApi = this.field_types[this.p_name].rawDataApi;
      let _this = this;
      http.post(this.rawDataApi, params, function(error, response) {
        // console.log("fieldsList Data", response);
        _this.rawData = response;
        const getUniqueCode = [];
        const uniqueCoCode = [];
        _this.tableRows.forEach((ele, key) => {
          Object.keys(_this.rawData[ele.title]).forEach((val, k) => {
            if (!getUniqueCode.includes(val)) {
              getUniqueCode.push(val);
              uniqueCoCode.push(_this.rawData[ele.title][val]);
            }
          });
          // console.log(getUniqueCode);
        });
        // console.log(uniqueCoCode);
        _this.uniqueCoCode = uniqueCoCode;
        _this.searchData = _this.uniqueCoCode;
      });
    },
    filter() {
      this.getPScore();
    },
    searchCompany() {
      if (
        this.searchText === null ||
        this.searchText === "" ||
        this.searchText.length <= 2
      ) {
        this.uniqueCoCode = this.searchData;
        return this.uniqueCoCode;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.uniqueCoCode = this.searchData.filter(rd => {
          return rd.name
            ? rd.name.toLowerCase().includes(this.searchText.toLowerCase())
            : false;
        });
      }
    }
  },
  computed: {
    // getData: function(title) {
    //   return rawData[title] && rawData[title].length > 0 ? rawData[title] : [];
    // }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/market-data/p-score-analysis.vue